import { render, staticRenderFns } from "./Alphabet.vue?vue&type=template&id=9b2c9b62&lang=pug&"
import script from "./Alphabet.vue?vue&type=script&lang=js&"
export * from "./Alphabet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports